module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-wrapper",
    class: _vm.notify_container_Class,
    style: ({
      left: _vm.leftPos + 'px'
    })
  }, [(!_vm.inviteShow) ? _c('div', {
    staticClass: "notify-head"
  }, [_vm._v("Notifications")]) : _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "notify-head"
  }, [_vm._v("Invite")]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.toggleNotify()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/closeIcon.svg"),
      "width": "16"
    }
  })])]), _vm._v(" "), (!_vm.inviteShow) ? _c('div', {
    staticClass: "notify-body"
  }, [_c('div', {
    staticClass: "notify-invite"
  }, [_c('h2', {
    staticClass: "invite-head"
  }, [_vm._v("Invite 10 creators, get 3 months free!")]), _vm._v(" "), _c('v-btn', {
    staticClass: "purple-btn",
    on: {
      "click": function($event) {
        _vm.toggleNotify()
      }
    }
  }, [_vm._v("\n                Invite\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "notify-main"
  }, [_c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(16)]), _vm._v(" "), _vm._m(17)])])]) : _c('div', {
    staticClass: "invite-body"
  }, [_c('div', {
    staticClass: "invite-upper"
  }, [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "purple-btn"
  }, [_vm._v("\n                    Copy link\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n                Link expires in 72 hours & can only be used once\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "invite-lower"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "invite-wrapper"
  }, [_c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(21)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("s a assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/demo-n-image.png"),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/send_airplane.svg"),
      "width": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "invite-head"
  }, [_vm._v("\n                    Invite 10 creators, get 3 months free!\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "invite-sub-head"
  }, [_vm._v("\n                    *Creators invited must subscribe to be eligible\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-normal"
  }, [_vm._v("You have "), _c('span', [_vm._v("4")]), _vm._v(" more signups tp go!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a9d2c44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notificationDrawer/index.vue
// module id = 1809
// module chunks = 180